export default __webpack_public_path__ + "b56511a07dda84d516dccbc073e3d995.svg";